/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import Logger from "../lib/logger";
import Nav from "../partials/Nav";
import MobileNav from "../partials/MobileNav";
import MediaMuteToggle from "../partials/MediaMuteToggle";
import CookieConsent from "../partials/CookieConsent";
import Woobox from "../partials/Woobox";

export default function () {
  const NAME = 'Global';
  Logger.info(`${NAME} > loading`);

  // Vars
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒


  // Logic
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

  /**
   * init --- Initialization block
   */
  function init() {
    Logger.info(`${NAME} > init`);

    const headerDom = document.querySelector('.theme-header');
    if (headerDom) {
      new Nav(headerDom).init();
      new MobileNav(headerDom).init();
    }

    // Hero and Video block are both placeable anywhere, not tied to one
    // template, and a page could have more than one of either — wire up
    // every mute toggle found rather than assuming a single instance.
    document.querySelectorAll('[data-media-mute-toggle]').forEach((button) => {
      new MediaMuteToggle(button).init();
    });

    const cookieConsentDom = document.querySelector('[data-cookie-consent]');
    if (cookieConsentDom) new CookieConsent(cookieConsentDom).init();

    // Any "#woobox" link (ACF link field or nav Custom Link) opens the
    // Woobox quiz popup — see partials/Woobox.js.
    new Woobox().init();
  }

  // Do not edit below this line...
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
  Logger.info(`${NAME} > loaded`);

  init();
}
